import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { CourseJsonLd } from "gatsby-plugin-next-seo";
import Copy, { Bold } from "@nib-components/copy";
import { Stack, Box } from "@nib/layout";
import Heading from "@nib-components/heading";

const StyledBox = styled.div`
  border-bottom: 2px solid hsla(0, 0%, 0%, 0.1);
  padding: 1rem;
`;

export const LessonWithoutAccordion = ({ name, title, lessonNumber }) => {
  return (
    <StyledBox>
      <CourseJsonLd courseName={name} description={title} providerName="nib and nurture baby" />
      <Stack>
        <Heading component="h4" size={{ xs: 4, md: 4 }}>
          Module {lessonNumber}
        </Heading>
        <Copy small>{name}</Copy>
      </Stack>
    </StyledBox>
  );
};

export const LessonWithAccordion = ({ name, title, lessons, isMobile }) => {
  return (
    <>
      <CourseJsonLd courseName={name} description={title} providerName="nib and nurture baby" />
      <Stack space={{ xs: 2, md: 4 }}>
        {Array.isArray(lessons) && lessons.length ? (
          lessons.map((lesson, j) => {
            return !isMobile ? (
              <Box key={j}>
                Lesson {j + 1} - <Bold>{lesson.title}</Bold>
              </Box>
            ) : (
              <Box key={j}>
                <Bold>Lesson {j + 1}</Bold> <br /> {lesson.title}
              </Box>
            );
          })
        ) : (
          <Copy></Copy>
        )}
      </Stack>
    </>
  );
};

LessonWithoutAccordion.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  lessonNumber: PropTypes.number,
};

LessonWithAccordion.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  lessons: PropTypes.array,
  isMobile: PropTypes.bool,
};
